import { Group, Paper, Stack, Switch, TextInput } from '@common/ui'
import { com, kotlin } from '@eidu/web'
import ItemList from './ItemList'
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'
import TrimmedTextInput from './TrimmedTextInput'
import MultiAnswer = com.eidu.sharedlib.form.definition.MultiAnswer
import Item = com.eidu.sharedlib.form.definition.Item
import KtList = kotlin.collections.KtList

type MultiAnswerItemProps = {
  item: MultiAnswer
  onChange?: (item: MultiAnswer) => void
}

const MultiAnswerItem: React.FC<MultiAnswerItemProps> = ({ item, onChange }) => {
  const handleItemsChange = (newItems: KtList<Item>) => {
    onChange?.(
      withKey(item.copy(item.prompt, item.key, newItems, item.required, item.addLabel, item.removeLabel), item)
    )
  }

  return (
    <Paper withBorder radius="sm" p="xs">
      <Stack gap="md">
        <Group gap="md" wrap="nowrap" align="flex-start">
          <TrimmedTextInput
            style={{ flex: 1 }}
            label="Prompt"
            value={item.prompt}
            onChange={(e) =>
              onChange?.(
                withKey(
                  item.copy(e.target.value, item.key, item.items, item.required, item.addLabel, item.removeLabel),
                  item
                )
              )
            }
            disabled={!onChange}
          />
          <FormKeyField
            value={item.key}
            onChange={(e) =>
              onChange?.(
                withKey(
                  item.copy(item.prompt, e.target.value, item.items, item.required, item.addLabel, item.removeLabel),
                  item
                )
              )
            }
            disabled={!onChange}
          />
        </Group>
        <Group gap="md" wrap="nowrap" align="flex-start">
          <TextInput
            style={{ flex: 1 }}
            label="Add Label"
            value={item.addLabel}
            onChange={(e) =>
              onChange?.(
                withKey(
                  item.copy(item.prompt, item.key, item.items, item.required, e.target.value, item.removeLabel),
                  item
                )
              )
            }
            disabled={!onChange}
          />
          <TextInput
            style={{ flex: 1 }}
            label="Remove Label"
            value={item.removeLabel}
            onChange={(e) =>
              onChange?.(
                withKey(
                  item.copy(item.prompt, item.key, item.items, item.required, item.addLabel, e.target.value),
                  item
                )
              )
            }
            disabled={!onChange}
          />
          <Switch
            checked={item.required}
            onChange={(e) =>
              onChange?.(
                withKey(
                  item.copy(item.prompt, item.key, item.items, e.target.checked, item.addLabel, item.removeLabel),
                  item
                )
              )
            }
            disabled={!onChange}
            label="Required"
          />
        </Group>
        <Paper radius="sm" p="xs" bg="var(--trellis-color-surface)">
          <ItemList items={item.items} onChange={onChange && handleItemsChange} />
        </Paper>
      </Stack>
    </Paper>
  )
}

export default MultiAnswerItem
